<template>
  <span
    v-if="visible"
    v-tooltip="{ content: label, placement: 'top', offset: 6 }"
    class="lead-communication-delivery-status"
    :class="`lead-communication-delivery-status--${code}`"
    :aria-label="label"
  >
    <svg
      v-if="code === 'pending'"
      class="lead-communication-delivery-status__icon"
      viewBox="0 0 14 14"
      aria-hidden="true"
    >
      <circle cx="7" cy="7" r="5.25" />
      <path d="M7 4.1v3.2l2.2 1.3" />
    </svg>
    <svg
      v-else-if="code === 'failed'"
      class="lead-communication-delivery-status__icon"
      viewBox="0 0 14 14"
      aria-hidden="true"
    >
      <circle cx="7" cy="7" r="5.25" />
      <path d="M7 3.9v3.8" />
      <path d="M7 10.1h.01" />
    </svg>
    <svg
      v-else-if="code === 'sent'"
      class="lead-communication-delivery-status__icon"
      viewBox="0 0 14 14"
      aria-hidden="true"
    >
      <path d="M1.8 7.2l3 3 7.2-7" />
    </svg>
    <svg
      v-else-if="code === 'delivered' || code === 'read'"
      class="lead-communication-delivery-status__icon lead-communication-delivery-status__icon--double"
      viewBox="0 0 18 14"
      aria-hidden="true"
    >
      <path d="M.9 7.2l3 3 7.2-7" />
      <path d="M6.6 7.2l3 3 7.2-7" />
    </svg>
    <span>{{ label }}</span>
  </span>
</template>

<script>
const STATUS_PRESENTATION = {
  pending: 'Pending',
  sent: 'Sent',
  delivered: 'Delivered',
  failed: 'Failed'
}

export default {
  name: 'LeadCommunicationDeliveryStatus',
  props: {
    status: {
      type: [Object, String],
      default: null
    },
    communicationMethods: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    code() {
      const value = typeof this.status === 'string' ? this.status : this.status && this.status.code
      return String(value || '').toLowerCase()
    },
    visible() {
      return Boolean(this.code && !['recorded', 'received'].includes(this.code))
    },
    statusName() {
      return typeof this.status === 'object' && this.status ? this.status.name : ''
    },
    isEmail() {
      return this.communicationMethods.some(method => {
        const value = String(method.code || method.id || method.name || '').toLowerCase()
        return value.includes('email')
      })
    },
    label() {
      if (this.code === 'read') return this.isEmail ? 'Opened' : 'Read'
      return STATUS_PRESENTATION[this.code] || this.statusName || this.code
    }
  }
}
</script>

<style lang="scss" scoped>
.lead-communication-delivery-status {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  color: #637687;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
}

.lead-communication-delivery-status--pending {
  color: #a96f00;
}

.lead-communication-delivery-status--delivered {
  color: #267b59;
}

.lead-communication-delivery-status--read {
  color: #167eb7;
}

.lead-communication-delivery-status--failed {
  color: #b33b3b;
}

.lead-communication-delivery-status__icon {
  width: 12px;
  height: 12px;
  flex: 0 0 12px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.7;
}

.lead-communication-delivery-status__icon--double {
  width: 16px;
  flex-basis: 16px;
}
</style>
